import { Group } from '@mantine/core';
import * as React from 'react';
import { FormLike } from '../../../../../react-commons/hooks/useMultiForm';
import { Buttons } from '../../../../../react-commons/utils/form/buttons';

export const Form_EditableDisplayBar = ({
    form,
    canSubmitDefaultValue,
}: {
    form: FormLike;
    canSubmitDefaultValue: boolean;
}) => {
    return (
        <Group gap="xs" justify="flex-end" pt="xs" pr="xs">
            <Buttons.Reset form={form}>Reset</Buttons.Reset>
            <Buttons.Submit form={form} canSubmitDefaultValue={canSubmitDefaultValue}>
                Save
            </Buttons.Submit>
        </Group>
    );
};
